import './style/styles-index.scss'

import { createComponent } from '@bigyouth/base'
import * as features from './features/exports/index'

Object.values(features).forEach(createComponent)
